export const INVALIDATE_CONSULTATION = 'INVALIDATE_CONSULTATION';

export const INITIALIZE_CONSULTATION_REQUEST = 'INITIALIZE_CONSULTATION_REQUEST';
export const INITIALIZE_CONSULTATION_SUCCESS = 'INITIALIZE_CONSULTATION_SUCCESS';
export const INITIALIZE_CONSULTATION_ERROR = 'INITIALIZE_CONSULTATION_ERROR';

export const SAVE_ANSWER_REQUEST = 'SAVE_ANSWER_REQUEST';
export const SAVE_ANSWER_SUCCESS = 'SAVE_ANSWER_SUCCESS';
export const SAVE_ANSWER_ERROR = 'SAVE_ANSWER_ERROR';

export const CONSULTATION_AGGRESSORS_REQUEST = 'CONSULTATION_AGGRESSORS_REQUEST';
export const CONSULTATION_AGGRESSORS_SUCCESS = 'CONSULTATION_AGGRESSORS_SUCCESS';
export const CONSULTATION_AGGRESSORS_FAILURE = 'CONSULTATION_AGGRESSORS_FAILURE';

export const CONSULTATION_FRAGRANCES_REQUEST = 'CONSULTATION_FRAGRANCES_REQUEST';
export const CONSULTATION_FRAGRANCES_SUCCESS = 'CONSULTATION_FRAGRANCES_SUCCESS';
export const CONSULTATION_FRAGRANCES_FAILURE = 'CONSULTATION_FRAGRANCES_FAILURE';

export const FEEDBACK_FRAGRANCES_REQUEST = 'FEEDBACK_FRAGRANCES_REQUEST';
export const FEEDBACK_FRAGRANCES_SUCCESS = 'FEEDBACK_FRAGRANCES_SUCCESS';
export const FEEDBACK_FRAGRANCES_FAILURE = 'FEEDBACK_FRAGRANCES_FAILURE';

export const FINISH_CONSULTATION = 'FINISH_CONSULTATION';
export const COMPLETE_HAIR_PROFILE = 'COMPLETE_HAIR_PROFILE';

export const CONSULTATION_SCORING_REQUEST = 'CONSULTATION_SCORING_REQUEST';
export const CONSULTATION_SCORING_SUCCESS = 'CONSULTATION_SCORING_SUCCESS';
export const CONSULTATION_SCORING_FAILURE = 'CONSULTATION_SCORING_FAILURE';

export const CONSULTATION_INGREDIENTS_REQUEST = 'CONSULTATION_INGREDIENTS_REQUEST';
export const CONSULTATION_INGREDIENTS_SUCCESS = 'CONSULTATION_INGREDIENTS_SUCCESS';
export const CONSULTATION_INGREDIENTS_FAILURE = 'CONSULTATION_INGREDIENTS_FAILURE';

export const GET_HAIR_PROFILE_REQUEST = 'GET_HAIR_PROFILE_REQUEST';
export const GET_HAIR_PROFILE_SUCCESS = 'GET_HAIR_PROFILE_SUCCESS';
export const GET_HAIR_PROFILE_ERROR = 'GET_HAIR_PROFILE_ERROR';

export const BUFFER_ANSWER = 'BUFFER_ANSWER';
export const CLEAR_ANSWER_BUFFER = 'CLEAR_ANSWER_BUFFER';

export const IS_EMAIL_CAPTURE_EXIT_CONSULTATION_MODAL_OPEN =
  'IS_EMAIL_CAPTURE_EXIT_CONSULTATION_MODAL_OPEN';
